export class Policies {

  public static readonly TPIQAPI = {
    FUNCTIONAL_ANALYSIS: {
      READ: {
        name: 'read'
      },
      WRITE: {
        name: 'write'
      },
      DELETE: {
        name: 'delete'
      },
      ADD_CHARACTERISTIC: {
        name: 'functional-analysis-add-characteristic'
      },
      CREATE_TEMPLATE: {
        name: 'functional-analysis/global-library/analysis-type/:type/id/:id-POST'
      },
      IMPORT_FROM_TEMPLATE: {
        name: 'functional-analysis/global-library/analysis-type/:type/id/:id-PUT'
      },
      DELETE_TEMPLATE: {
        name: 'functional-analysis/global-library/analysis-type/:type/id/:id-DELETE'
      },
      COPY_FROM_FUNCTIONAL_ANALYSIS: {
        name: 'functional-analysis-copy-from-functional-analysis'
      }
    }
  };

  public static readonly CSAPI = {
    CSAPI_TUNE_COMP_SEARCH_CONTROLLER_SAVE_COMP_SEARCH: {
      name: 'csapi-tune-comp-search-controller-save-comp-search',
    },
    CSAPI_TUNE_COMP_SEARCH_CONTROLLER_GET_SAVED_COMP_SEARCHES: {
      name: 'csapi-tune-comp-search-controller-get-saved-comp-searches',
    },
    CSAPI_TUNE_COMP_SEARCH_CONTROLLER_LOAD_COMP_SEARCH: {
      name: 'csapi-tune-comp-search-controller-load-comp-search',
    },
    CSAPI_TUNE_COMP_SEARCH_CONTROLLER_DELETE_COMP_SEARCH: {
      name: 'csapi-tune-comp-search-controller-delete-comp-search',
    },
    CSAPI_COMP_SEARCH_LIBRARY_CONTROLLER_GET_SAVED_GLOBAL_COMP_SEARCHES: {
      name: 'csapi-comp-search-library-controller-get-saved-global-comp-searches'
    },
    CSAPI_COMP_SEARCH_LIBRARY_CONTROLLER_LOAD_GLOBAL_COMP_SEARCH: {
      name: 'csapi-comp-search-library-controller-load-global-comp-search'
    },
    CSAPI_COMP_SEARCH_LIBRARY_CONTROLLER_SAVE_GLOBAL_COMP_SEARCH: {
      name: 'csapi-comp-search-library-controller-save-global-comp-search'
    },
    CSAPI_COMP_SEARCH_LIBRARY_CONTROLLER_DELETE_GLOBAL_COMP_SEARCH: {
      name: 'csapi-comp-search-library-controller-delete-global-comp-search'
    }
  };

  public static readonly GET_ENTITIES = 'entities-GET';
  public static readonly GET_MNE_WORLD = 'wtp/mne-world-GET';

  public static readonly COMPLIANCE_CENTRAL_ACCESS = 'ccapi-full-access';

  public static readonly MASTERFILE_ACCESS = 'master_file_access';

  public static readonly CORE_API_UPDATE_CONTROLLER_SAVED_MATCHED_DATA = 'coreapi-update-controller-save-matched-data';

}
